module.exports = __webpack_public_path__ + "img/img_product_FGF_6.ff308f54.jpg";